export const formatDynamicFieldKey = (key: string): string => '{{' + key + '}}';
